type StoreDomain =
  | 'rsmoto.sk'
  | 'new.gasgas.sk'
  | 'new.ktmbratislava.sk'
  | 'new.cfmotobratislava.sk';

const isEshopMap: Record<StoreDomain, boolean> = {
  'rsmoto.sk': true,
  'new.gasgas.sk': false,
  'new.ktmbratislava.sk': false,
  'new.cfmotobratislava.sk': false,
};

export const useCurrentStore = () => {
  const currentStore = process.env.NEXT_PUBLIC_CURRENT_STORE as StoreDomain | undefined;

  const isValidStore = currentStore && isEshopMap[currentStore] !== undefined;

  return {
    isGasGas: isValidStore && currentStore === 'new.gasgas.sk',
    isKtmBratislava: isValidStore && currentStore === 'new.ktmbratislava.sk',
    isCFMoto: isValidStore && currentStore === 'new.cfmotobratislava.sk',
    isEshop: isValidStore && isEshopMap[currentStore],
    isLandingPage: isValidStore && !isEshopMap[currentStore],
    currentStore,
  };
};
